import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type MediaData = {
  assetId: string;
  mediaType: 'image' | 'video';
  mediaSrc: string;
  name?: string;
};

export type commonStateType = {
  isFromPhoto?: boolean;
  selectedMedia?: MediaData | null;
};

const initialState: commonStateType = {
  isFromPhoto: false,
  selectedMedia: null
};

export const commonStateSlice = createSlice({
  name: 'commonStateSlice',
  initialState,
  reducers: {
    setCommonState: (state, action) => {
      const { isFromPhoto } = action.payload;
      state.isFromPhoto = isFromPhoto;
      return state;
    },
    setSelectedMedia: (state, action) => {
      state.selectedMedia = action.payload;
      return state;
    },
    clearSelectedMedia: state => {
      state.selectedMedia = null;
      return state;
    },
    resetCommonState: () => {
      return initialState;
    }
  }
});

export const { setCommonState, setSelectedMedia, clearSelectedMedia } =
  commonStateSlice.actions;

export const getCommonState = (state: RootState) => state.commonStateSlice;
